var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPastagemRegadio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    transform: "translate(12695 452)",
    fill: "#36364a",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b",
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-12695 -452)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(12693.561 448.844)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.439,27.239a1.543,1.543,0,0,0-1.661-1.55H25.246c-.332,0-.443,0-.664-.332a21.959,21.959,0,0,0-1.218-2.215.83.83,0,0,0-.886-.554H20.484V18.824a1.846,1.846,0,0,0-1.55-1.993V15.28h1.329a1.162,1.162,0,0,0,1.218-1.218V12.291a.968.968,0,0,0-.664-1c-.332,0-.775-.111-1.107-.111h-5.2a1.279,1.279,0,0,0-1.329,1.329v1.55a1.279,1.279,0,0,0,1.329,1.329h1.218V16.83c-.332.221-.664.221-.886.443-.775.443-.664,3.875-.664,5.093V22.7H12.512a1.2,1.2,0,0,0-1.218.775c-.332.664-.664,1.218-1,1.882a.836.836,0,0,1-.775.443H3.433c-1.439,0-1.993.554-1.993,1.993V28.9c0,1.439.554,1.993,1.993,1.993H31.668a1.543,1.543,0,0,0,1.55-1.661V27.349Zm-18.6-12.955c-.332,0-.554-.111-.554-.554V12.4c0-.443.111-.664.554-.664h5.2c.332,0,.443.221.443.554V13.73c0,.332-.111.443-.443.443H14.727Zm1.439,3.433h2.436a.815.815,0,0,1,.886.886v3.875H15.28V18.6a.815.815,0,0,1,.886-.886ZM12.4,23.7a.773.773,0,0,1,.443-.221h9.522a.442.442,0,0,1,.443.221c.332.554.664,1.218,1,1.882H11.4C11.737,24.913,12.069,24.249,12.4,23.7Zm20.042,4.872c0,1-.111,1.107-1.107,1.107H3.322c-.554,0-.775-.221-.775-.775V27.571c0-.886.111-1.107,1.107-1.107H26.8a30.315,30.315,0,0,0,3.211,0h1.661c.664,0,.886.221.886.886v1.107Z",
    fill: "#36364a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.758,16.277a13.045,13.045,0,0,0,2.1-1.218.93.93,0,0,0,0-1.55,13.045,13.045,0,0,0-2.1-1.218,2.129,2.129,0,1,0,0,3.986ZM4.1,13.509a1.105,1.105,0,0,1,1.329-.443,17.915,17.915,0,0,1,1.993,1.107v.221c-.664.332-1.329.775-1.993,1.107A1.046,1.046,0,0,1,4.1,14.948a1.642,1.642,0,0,1,0-1.439Z",
    fill: "#36364a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.128,15.059a19.26,19.26,0,0,0,1.993,1.218,2.129,2.129,0,1,0,0-3.986,13.045,13.045,0,0,0-2.1,1.218.93.93,0,0,0,0,1.55Zm.443-.886c.664-.332,1.329-.775,1.993-1.107a1.105,1.105,0,0,1,1.329.443,1.164,1.164,0,0,1,0,1.439,1.348,1.348,0,0,1-1.329.554,17.915,17.915,0,0,1-1.993-1.107Z",
    fill: "#36364a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.024,10.3a.816.816,0,0,0,1,.775,6.765,6.765,0,0,0,1.55-.775,1.525,1.525,0,0,0,.554-1.772,1.639,1.639,0,0,0-3.1,0A5.713,5.713,0,0,1,24.8,9.744h0V10.3Zm1-1.329a.523.523,0,0,1,.554-.554.91.91,0,0,1,.664.443.734.734,0,0,1-.221.775,10.289,10.289,0,0,1-1.107.554,3.787,3.787,0,0,1,.111-1.218Z",
    fill: "#36364a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.419,10.408c.443.221,1,.443,1.439.664a.79.79,0,0,0,1.107-.664V9.744h0a3.066,3.066,0,0,0-.111-1A1.461,1.461,0,0,0,8.3,7.529a1.665,1.665,0,0,0-1.55,1.107,1.63,1.63,0,0,0,.664,1.882Zm.221-1.55A.91.91,0,0,1,8.3,8.415a.523.523,0,0,1,.554.554,5.433,5.433,0,0,0,.111,1.218,10.289,10.289,0,0,1-1.107-.554.572.572,0,0,1-.332-.775Z",
    fill: "#36364a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.685,21.038a1.568,1.568,0,0,0,1.55-1,1.525,1.525,0,0,0-.554-1.772,6.765,6.765,0,0,0-1.55-.775c-.554-.221-1,.221-1.107.775v.443h0a2.384,2.384,0,0,0,.221,1.218A1.434,1.434,0,0,0,26.685,21.038Zm.443-2.1a1.6,1.6,0,0,1,.221.775c0,.221-.443.443-.554.332-.221,0-.554-.221-.554-.443-.111-.332,0-.775-.111-1.329a4.3,4.3,0,0,1,1.218.664Z",
    fill: "#36364a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.637,17.606a5.934,5.934,0,0,0-1.218.554,1.484,1.484,0,0,0-.664,1.772,1.7,1.7,0,0,0,1.661,1.107A1.44,1.44,0,0,0,9.855,19.82a2.159,2.159,0,0,1,.111-.886v-.443c0-.886-.554-1.218-1.329-.886ZM8.858,19.6c0,.221-.332.443-.554.443A.91.91,0,0,1,7.64,19.6c0-.221,0-.554.221-.664a10.289,10.289,0,0,1,1.107-.554A3.787,3.787,0,0,1,8.858,19.6Z",
    fill: "#36364a"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPastagemRegadio);
export default __webpack_public_path__ + "static/media/pastagem_regadio.7e8a12346cd622b68cbe78b75bc1cb51.svg";
export { ForwardRef as ReactComponent };